export default "__VITE_ASSET__qpjjhz2i__"